export default __webpack_public_path__ + "static/media/0x104592a158490a9228070e0a8e5343b499e125d0.0c693be9.png";